import Countdown from 'react-countdown'
import { StatBar } from '../stats/StatBar'
import { Histogram } from '../stats/Histogram'
import { GameStats, loadGameLostFromLocalStorage, loadGameStatusFromLocalStorage, loadGameWonFromLocalStorage } from '../../lib/localStorage'
import { shareStatus } from '../../lib/share'
import { BaseModal } from './BaseModal'
import {
  STATISTICS_TITLE,
  GUESS_DISTRIBUTION_TEXT,
  NEW_WORD_TEXT,
  SHARE_TEXT,
} from '../../constants/strings'
import pointer from "../../pointer.png";
import moment from 'moment'

type Props = {
  isOpen: boolean
  handleClose: () => void
  guesses: string[]
  finalGameStats: string
  hurdleGameStats: GameStats
  isGameLost: boolean
  isGameWon: boolean
  handleShare: () => void
  isHardMode: boolean
  currentStep: number
  finalWon: boolean
  currentStatus: string
  totalStatus: string
  words: any
  tomorrow: number
  solutionIndex: string
}

export const StatsModal = ({
  isOpen,
  handleClose,
  guesses,
  finalGameStats,
  hurdleGameStats,
  isGameLost,
  isGameWon,
  handleShare,
  isHardMode,
  currentStep,
  finalWon,
  currentStatus,
  totalStatus,
  words,
  tomorrow,
  solutionIndex
}: Props) => {
  
  const epochMs = new Date("January 1, 2022").valueOf()
  const msInDay = 86400000
  const today = new Date();  
  let now = today.getTime();
  if (moment().isDST()) {
    now = moment(now).add(1, "hour").valueOf();
  }
  let index1 = Math.floor((now - epochMs) / msInDay)
  let nextday = (index1 + 1) * msInDay + epochMs
  if (moment().isDST()) {
    nextday = moment(nextday).subtract(1, "hour").valueOf();
  }
  const _finalGameStats = JSON.parse(finalGameStats)

  // _finalGameStats.totalGames += hurdleGameStats.totalGames;
  // _finalGameStats.gamesFailed += hurdleGameStats.gamesFailed;
  // _finalGameStats.bestStreak += hurdleGameStats.bestStreak;
  // if (hurdleGameStats.currentStreak === 0) {
  //   _finalGameStats.currentStreak = 0;
  // } else {
  //   _finalGameStats.currentStreak += hurdleGameStats.currentStreak;
  // }

  // if (_finalGameStats.bestStreak < _finalGameStats.currentStreak) {
  //   _finalGameStats.bestStreak = _finalGameStats.currentStreak
  // }

  // _finalGameStats.successRate = Math.round(
  //   (100 * (_finalGameStats.totalGames - _finalGameStats.gamesFailed)) / Math.max(_finalGameStats.totalGames, 1)
  // )

  if (hurdleGameStats.totalGames <= 0) {
    return (
      <BaseModal
        title={STATISTICS_TITLE}
        isOpen={isOpen}
        handleClose={handleClose}
        isStats={true}
      >
        <StatBar gameStats={_finalGameStats} />
        {_finalGameStats?.totalGames > 0 && <StatBar gameStats={hurdleGameStats} />}
        
      </BaseModal>
    )
  }
  return (
    <BaseModal
      title={STATISTICS_TITLE}
      isOpen={isOpen}
      handleClose={handleClose}
      isStats={true}
    >
      <StatBar gameStats={_finalGameStats} />
      {(isGameLost || isGameWon || finalWon || loadGameWonFromLocalStorage() || loadGameLostFromLocalStorage()) && (
        <>
          <div className="share-wrapper">
          <button
            type="button"
            className="mt-2 w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm share"
            onClick={() => {
              let _currentSatus = currentStatus
              if (loadGameWonFromLocalStorage() || loadGameLostFromLocalStorage()) {
                const status = loadGameStatusFromLocalStorage();
                if (status) {
                  _currentSatus = loadGameStatusFromLocalStorage() || "";
                } else {
                  _currentSatus = totalStatus + currentStatus;
                }
              } else if (!loadGameStatusFromLocalStorage() && (isGameLost || isGameWon || finalWon)) { //localstorage is not available
                _currentSatus = totalStatus;
              }
              shareStatus(guesses, _currentSatus, isGameLost, isHardMode, currentStep, words, solutionIndex)
              handleShare()
            }}
          >
            {SHARE_TEXT}
          </button>
             <a target="_blank"  className="seemore" href="https://www.arkadium.com/free-online-games/best/?ref=hurdle" rel="noreferrer" >Play more games <img src={pointer} alt="logo" /></a>
        </div>
        <div style={{ display: "inline-flex"}} className="dark:text-white font-medium text-lg">
            <h5>{NEW_WORD_TEXT}</h5>
            &nbsp;
            <Countdown
              className="dark:text-gray-100"
              date={nextday}
              daysInHours={true}
            />
        </div>
        </>
      )}
      <div className="histogram-background">
      <h4 style={{padding: "10px"}} className="text-lg leading-6 font-medium text-gray-900 dark:text-gray-100">
        {GUESS_DISTRIBUTION_TEXT}
      </h4>
        <div className="histogram-wrapper">
        <Histogram isFinal gameStats={_finalGameStats} />
        <Histogram isHurdle gameStats={hurdleGameStats} />
      </div>
      </div>
      
    </BaseModal>
  )
}
